import { ReactNode } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material/styles";

interface SectionCardProps {
  icon?: ReactNode;
  title: string;
  children?: ReactNode;
  sx?: SxProps<Theme>;
}

const SectionCard = ({
  icon,
  title,
  children,
  sx,
}: SectionCardProps): JSX.Element => {
  const sxObj = typeof sx === "function" ? sx({} as Theme) : sx;
  const isFitContent =
    sxObj &&
    typeof sxObj === "object" &&
    "height" in sxObj &&
    sxObj.height === "fit-content";
  const hasFlex =
    sxObj && typeof sxObj === "object" && "flex" in sxObj && sxObj.flex === 1;

  return (
    <Box
      sx={{
        border: theme => `1px solid ${theme.palette.otherOutlineBorder.main}`,
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0.5em 1em",
          backgroundColor: "otherBackground.main",
          borderBottom: theme =>
            `1px solid ${theme.palette.otherOutlineBorder.main}`,
        }}
      >
        <Box>
          <Typography
            variant="body2Regular"
            sx={{ fontSize: "16px" }}
            component="span"
          >
            {title}
          </Typography>
        </Box>

        {icon ? (
          <Box sx={{ display: "flex", alignItems: "center" }}>{icon}</Box>
        ) : null}
      </Box>

      <Box
        sx={{
          flex: isFitContent ? 1 : hasFlex ? 1 : undefined,
          minHeight: isFitContent ? 0 : hasFlex ? 0 : undefined,
          maxHeight: isFitContent ? "100%" : undefined,
          display: "flex",
          flexDirection: "column",
          overflow: isFitContent ? "hidden" : undefined,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SectionCard;
